import { getFullCountryList } from './countryList';
import { Component } from '../models/be/db/FormSpecification';

const addressComponents: Component[] = [
	{
		fieldNames: ['addressHistory.fromDate'],
		name: 'DataCaptureField',
		props: {
			type: 'date',
			label: 'From',
			max: ['now'],
			maxErrorMessage: 'From date can not be in the future.',
			required: true
		},
		id: Math.random().toString()
	},
	{
		fieldNames: ['addressHistory.toDate'],
		name: 'DataCaptureField',
		props: {
			type: 'date',
			label: 'To',
			max: ['now'],
			maxErrorMessage: 'To date can not be in the future.',
			required: true
		},
		id: Math.random().toString()
	},
	{
		fieldNames: [],
		name: 'AddressLookup',
		props: {},
		visible: null,
		id: Math.random().toString()
	},
	{
		fieldNames: ['addressHistory.country'],
		id: Math.random().toString(),
		name: 'DataCaptureField',
		props: {
			className: 'countryList',
			label: 'Country',
			required: true,
			type: 'comboBox',
			values: getFullCountryList()
		}
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.unitNumber'],
		name: 'DataCaptureField',
		props: {
			label: 'Unit/Flat/Apartment Number',
			maxLength: 10,
			pattern: '(^[ -~]*$)',
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: false,
			type: 'text'
		}
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.buildingName'],
		name: 'DataCaptureField',
		props: {
			label: 'Building Name',
			pattern: '(^[ -~]*$)',
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: false,
			type: 'text'
		}
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.streetNumber'],
		name: 'DataCaptureField',
		props: {
			label: 'Street Number',
			maxLength: 10,
			pattern: '(^[ -~]*$)',
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: false,
			type: 'text'
		}
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.streetName'],
		name: 'DataCaptureField',
		props: {
			label: 'Street Name',
			maxLength: 230,
			pattern: "(^[a-zA-Z0-9 \\(\\)\\-\\/'&]*$)",
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: true,
			type: 'text'
		}
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.suburb'],
		name: 'DataCaptureField',
		props: {
			label: 'Suburb / Town',
			maxLength: 255,
			pattern: '(^[ -~]*$)',
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: true,
			type: 'text'
		}
	},
	{
		fieldNames: ['addressHistory.state'],
		name: 'DataCaptureField',
		props: {
			type: ['if', ['equals', 'addressHistory.country', '"AUS"'], '"dropDownList"', '"text"'],
			label: 'State / Territory',
			maxLength: 50,
			pattern: '(^[ -~]*$)',
			patternErrorMessage: 'Please only use standard characters from A to Z, 0 to 9, and simple/standard punctuation.',
			required: true,
			values: [
				{ text: 'Australian Capital Territory', value: 'ACT' },
				{ text: 'New South Wales', value: 'NSW' },
				{ text: 'Northern Territory', value: 'NT' },
				{ text: 'Queensland', value: 'QLD' },
				{ text: 'South Australia', value: 'SA' },
				{ text: 'Tasmania', value: 'TAS' },
				{ text: 'Victoria', value: 'VIC' },
				{ text: 'Western Australia', value: 'WA' }
			]
		},
		id: Math.random().toString()
	},
	{
		id: Math.random().toString(),
		fieldNames: ['addressHistory.postcode'],
		name: 'DataCaptureField',
		props: {
			label: 'Post Code',
			maxLength: 15,
			required: true,
			type: 'text',
			pattern: [
				'if',
				['equals', 'addressHistory.country', '"GBR"'],
				'"^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2}[A-Za-z]{0,2})|([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$"',
				['if', ['equals', 'addressHistory.country', '"AUS"'], '"^[0-9]{4}$"', '"^([A-z0-9 \\-]+)$"']
			],
			patternErrorMessage: [
				'if',
				['equals', 'addressHistory.country', '"GBR"'],
				'"Please enter a valid postcode with a space after the district (e.g. SW1A 2AA)."',
				'"Please enter a valid postcode."'
			]
		}
	}
];

export const addressHistory: AddressHistoryComponents = {
	fieldNames: ['addressHistories'],
	components: addressComponents,
	numberOfYearsToCover: 5
};

export interface AddressHistoryComponents {
	fieldNames: string[];
	components: Component[];
	numberOfYearsToCover: number;
	setNavigationButtonsDisabled?: (disabled: boolean) => void;
}
